<template>
  <ion-app>
    <ion-content>
      <v-container fluid class="pa-0 pa-md-3" id="product">
        <!-- nav bar for mobile  -->
        <div class="van-hairline--bottom van-nav-bar" style="z-index: 1;" v-show="$vuetify.breakpoint.smAndDown">
          <div class="van-nav-bar__left">
            <i class="van-icon van-icon-arrow-left van-nav-bar__arrow" style="color: #000000 !important;" @click="onClickBack"></i>
          </div>
          <div class="van-ellipsis van-nav-bar__title">{{ $t("product.title") }}</div>
          <div class="van-nav-bar__right">
            <img src="../assets/img/icon_favorite.png" class="img-text-top-middle" v-show="favorite && $enableMembership" @click="toggleFavorite" />
            <img
              src="../assets/img/icon_favorite_n.png"
              class="img-text-top-middle"
              v-show="!favorite && $enableMembership"
              @click="toggleFavorite"
            />

            <div
              xclass="van-tabbar-item"
              style="margin-left:12px; margin-right:12px;"
              xstyle="float: right; margin-top: 15px; margin-left: 10px;"
              v-show="$enableShoppingCart"
            >
              <!-- <div class="van-nav-bar__right" style="top: 15px;" v-show="$enableShoppingCart"> -->
              <wc-tabbar-cart ref="cart" />
            </div>
            <!-- <div class="van-tabbar-item__text"></div>
            </div>-->
          </div>
        </div>

        <div class="content2" style>
          <!-- product image  -->
          <v-row>
            <v-col cols="12" md="6">
              <v-carousel
                height
                dark
                :class="{
                  carousel_mobile: $vuetify.breakpoint.smAndDown,
                  carousel_browser: $vuetify.breakpoint.mdAndUp,
                }"
              >
                <v-carousel-item
                  v-for="(item, index) in productImages"
                  :key="index"
                  :src="item.ImagePath"
                  @click.native="showCarouselItem(item)"
                ></v-carousel-item>
              </v-carousel>
              <v-dialog v-model="showTmpImage">
                <v-card class="mx-auto text-center">
                  <v-img :src="tmpImagePath" />
                  <v-card-actions><v-btn color="primary" class="ma-2" dark @click="showTmpImage = false"> Close </v-btn></v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
            <v-col cols="12" md="6">
              <!-- product title and description  -->
              <div style="padding: 30px;">
                <van-cell>
                  <div class="title">{{ curProduct.Title }}</div>
                  <div class="code">Product Code: {{ curProduct.Code }}</div>
                  <div class="product-note" v-show="curProduct.FreeShipping == false">{{ curProduct.exNote }}</div>
                </van-cell>

                <!-- price browser  -->
                <van-cell v-show="$vuetify.breakpoint.mdAndUp">
                  <div v-if="curProduct.Price == curProduct.SellingPrice" class="price">CAD ${{ curProduct.Price }}</div>
                  <div v-else class="price">
                    <span class="disc_price">CAD ${{ curProduct.SellingPrice }}</span>
                    <span class="ori_price">${{ curProduct.Price }}</span>
                  </div>
                </van-cell>

                <!-- add to cart browser  -->
                <van-cell v-show="$vuetify.breakpoint.mdAndUp">
                  <!-- out of stock  -->
                  <div
                    class="addto_cart"
                    v-show="$enableShoppingCart"
                    style="padding: 10px;"
                    v-if="(!curProduct.OnHandQty || curProduct.OnHandQty <= 0) && curProduct.NewProduct == 0"
                  >
                    <div>
                      <v-icon medium color="blue-grey darken-3">mdi-cart-off</v-icon>
                      <label xstyle="margin-left: 10px">Out of Stock</label>
                    </div>
                  </div>

                  <!-- comming soon  -->
                  <div
                    class="addto_cart"
                    v-show="$enableShoppingCart"
                    v-else-if="(!curProduct.OnHandQty || curProduct.OnHandQty <= 0) && curProduct.NewProduct != 0"
                    style="padding: 10px;"
                  >
                    <div>
                      <v-icon medium color="blue-grey darken-3">mdi-cart-off</v-icon>
                      <label xstyle="margin-left: 10px">Coming Soon</label>
                    </div>
                  </div>

                  <div class="addto_cart" @click="onClickAddToCart" v-show="$enableShoppingCart" v-else style="padding: 10px;">
                    <div>
                      <v-icon medium color="blue-grey darken-3">mdi-cart-arrow-down</v-icon>
                      <label xstyle="margin-left: 10px">{{ $t("product.add2Cart") }}</label>
                    </div>
                  </div>
                </van-cell>
              </div>
            </v-col>
          </v-row>

          <van-cell-group>
            <!-- product content images  -->
            <br />
            <van-cell>
              <div class="title" v-if="contentImages.length > 0">Product Details:</div>
              <div v-html="curProduct.Detail"></div>
              <!-- <pre>{{ curProduct.Detail }}</pre> -->
            </van-cell>

            <!-- <van-cell>

            </van-cell> -->

            <van-cell>
              <div class="text_center" v-for="(item, index) in contentImages" :key="index">
                <img
                  v-lazy="item.ImagePath"
                  :class="{
                    content_image_mobile: $vuetify.breakpoint.smAndDown,
                    content_image_browser: $vuetify.breakpoint.mdAndUp,
                  }"
                />
              </div>
            </van-cell>
          </van-cell-group>
        </div>

        <!-- price and cart mobile  -->
        <div class="footer " v-show="$vuetify.breakpoint.smAndDown">
          <v-row>
            <!-- price  -->
            <v-col cols="7" v-if="curProduct.Price == curProduct.SellingPrice" class="price text_center"> CAD ${{ curProduct.Price }} </v-col>
            <v-col cols="7" v-else class="price text-center">
              <span class="disc_price"><small>CAD</small> ${{ curProduct.SellingPrice }}</span
              >&nbsp;
              <span class="ori_price">${{ curProduct.Price }}</span>
            </v-col>

            <!-- cart  -->
            <!-- out of stock  -->
            <v-col
              cols="5"
              class="addto_cart"
              v-show="$enableShoppingCart"
              v-if="(!curProduct.OnHandQty || curProduct.OnHandQty <= 0) && curProduct.NewProduct == 0"
            >
              <v-icon medium color="blue-grey darken-3">mdi-cart-off</v-icon>
              <label style="margin-left: 10px">Out of Stock</label>
            </v-col>

            <!-- comming soon  -->
            <v-col
              cols="5"
              class="addto_cart"
              v-show="$enableShoppingCart"
              v-else-if="(!curProduct.OnHandQty || curProduct.OnHandQty <= 0) && curProduct.NewProduct != 0"
            >
              <v-icon medium color="blue-grey darken-3">mdi-cart-off</v-icon>
              <label style="margin-left: 10px">Coming Soon</label>
            </v-col>

            <!-- normal  -->
            <v-col cols="5" class="addto_cart" @click="onClickAddToCart" v-show="$enableShoppingCart" v-else>
              <v-icon medium color="blue-grey darken-3">mdi-cart-arrow-down</v-icon>
              <label class="text-boby-2 text-sm-body-1" style="margin-left: 5px">{{ $t("product.add2Cart") }}</label>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </ion-content>
  </ion-app>
</template>

<script>
export default {
  data() {
    return {
      curMemberId: 0,
      curProduct: { Title: "" },
      productImages: [],
      contentImages: [],
      favorite: false,
      //cartItemCount: "",
      current: 0,
      showTmpImage: false,
      tmpImagePath: "",
    };
  },
  // ------------------------------------------------------------------------
  computed: {
    routeBack() {
      return this.$store.state.product && this.$store.state.product.routeBack;
    },
    member() {
      return this.$store.state.member;
    },
    needReload() {
      return (this.member.MemberId && this.member.MemberId != this.curMemberId) || (!this.member.MemberId && this.curMemberId != 0);
    },
  },
  // ------------------------------------------------------------------------
  activated() {
    this.loadStates();
  },
  // ------------------------------------------------------------------------
  mounted() {
    this.curMemberId = null;
    this.loadStates();
  },
  // ------------------------------------------------------------------------
  methods: {
    // ------------------------------------------------------------------------ onClickBack
    onClickBack() {
      if (this.routeBack) {
        this.$router.back(-1);
      } else {
        this.$router.push({ name: "home" });
      }
    },
    // ------------------------------------------------------------------------ loadStates
    loadStates() {
      if (this.needReload) {
        if (this.$route.params.code) {
          this.getProductInfoByCode(this.$route.params.code);
        } else {
          if (this.$store.state.product) {
            if ("product" in this.$store.state.product) {
              this.curProduct = this.$store.state.product.product;
              if ("productImages" in this.$store.state.product && "contentImages" in this.$store.state.product) {
                this.productImages = this.$store.state.product.productImages;
                this.contentImages = this.$store.state.product.contentImages;
              } else {
                this.getProductImages();
              }
              if ("favorite" in this.$store.state.product) {
                this.favorite = this.$store.state.product.favorite;
              } else if (this.$enableMembership) {
                this.checkFavorite();
              } else {
                this.favorite = false;
              }
            } else if ("productId" in this.$store.state.product) {
              this.getProductInfo(this.$store.state.product.productId);
            } else {
              this.$router.push({ name: "classifyList" });
            }
          } else {
            this.$router.push({ name: "classifyList" });
          }
        }
      }
    },
    // ------------------------------------------------------------------------ saveStates
    saveStates() {
      this.$store.commit("product", {
        product: this.curProduct,
        productImages: this.productImages,
        contentImages: this.contentImages,
        favorite: this.favorite,
        routeBack: this.routeBack,
      });
    },
    // ------------------------------------------------------------------------ showCarouselItem
    showCarouselItem(item) {
      console.log(item);
      this.tmpImagePath = item.ImagePath;
      this.showTmpImage = true;
    },
    // ------------------------------------------------------------------------ getProductInfo
    getProductInfo(productId) {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
        productId: productId,
      };
      if (this.member.SessionId) {
        this.curMemberId = this.member.MemberId;
        obj.SessionId = this.member.SessionId;
        obj.SessionToken = this.member.SessionToken;
      } else {
        this.curMemberId = 0;
      }
      $this.$ajax2
        .post("getProduct", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            rpdata.data.data.Price = rpdata.data.data.Price.toFixed(2);
            rpdata.data.data.SellingPrice = rpdata.data.data.SellingPrice.toFixed(2);
            $this.curProduct = rpdata.data.data;
            $this.getProductImages();
            if ($this.$enableMembership) $this.checkFavorite();
          } else {
            $this.$router.push({ name: "home" });
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getProductInfoByCode
    getProductInfoByCode(productCode) {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
        productCode: productCode,
      };
      if (this.member.SessionId) {
        this.curMemberId = this.member.MemberId;
        obj.SessionId = this.member.SessionId;
        obj.SessionToken = this.member.SessionToken;
      } else {
        this.curMemberId = 0;
      }
      $this.$ajax2
        .post("getProduct", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            rpdata.data.data.Price = rpdata.data.data.Price.toFixed(2);
            rpdata.data.data.SellingPrice = rpdata.data.data.SellingPrice.toFixed(2);
            $this.curProduct = rpdata.data.data;
            $this.getProductImages();
            if ($this.$enableMembership) $this.checkFavorite();
          } else {
            $this.$router.push({ name: "home" });
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getProductImages
    getProductImages() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        productId: this.curProduct.Id,
      };
      $this.productImages = [];
      $this.contentImages = [];
      $this.$ajax2
        .post("GetProductImage", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            if (rpdata.data.data.length > 0) {
              for (let i = 0; i < rpdata.data.data.length; i++) {
                if (rpdata.data.data[i].Type == "T") {
                  $this.productImages.push(rpdata.data.data[i]);
                } else {
                  $this.contentImages.push(rpdata.data.data[i]);
                }
              }
            }
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ checkFavorite
    checkFavorite() {
      let $this = this;
      if ($this.member.SessionToken) {
        let obj = {
          AppVersion: this.$version,
          SessionId: this.member.SessionId,
          SessionToken: $this.member.SessionToken,
          productId: this.curProduct.Id,
        };
        $this.favorite = false;
        $this.$ajax2
          .post("CheckFavorite", obj, $this.$ajaxHeader)
          .then(function(rpdata) {
            if (rpdata.data.meta.code == "200") {
              $this.favorite = rpdata.data.data.favorite;
            }
          })
          .catch(function(err) {}); // eslint-disable-line
      } else {
        $this.favorite = false;
      }
    },
    // ------------------------------------------------------------------------ toggleFavorite
    toggleFavorite() {
      let $this = this;
      if ($this.member.SessionToken) {
        let obj = {
          AppVersion: this.$version,
          SessionId: this.member.SessionId,
          SessionToken: $this.member.SessionToken,
          productId: $this.curProduct.Id,
        };
        $this.$ajax2
          .post("ToggleFavorite", obj, $this.$ajaxHeader)
          .then(function(rpdata) {
            if (rpdata.data.meta.code == "200") {
              $this.favorite = rpdata.data.data.favorite; // !$this.favorite;
            } else {
              $this.$toast({
                message: rpdata.data.meta.msg,
                position: "bottom",
              });
            }
          })
          .catch(function(err) {}); // eslint-disable-line
      }
    },
    // ------------------------------------------------------------------------ onClickCustomerServices
    onClickCustomerServices() {
      let $this = this;
      $this.$router.push({ name: "customerServices" });
    },
    // ------------------------------------------------------------------------ onClickAddToCart
    onClickAddToCart() {
      let $this = this;
      if ($this.member.SessionToken) {
        let obj = {
          AppVersion: this.$version,
          SessionId: this.member.SessionId,
          SessionToken: $this.member.SessionToken,
          productId: $this.curProduct.Id,
          qty: 1,
        };
        $this.$ajax2
          .post("AddProductToCart", obj, $this.$ajaxHeader)
          .then(function(rpdata) {
            if (rpdata.data.meta.code == "200") {
              $this.$refs.cart.getCartQtyCount();
              $this.$toast({
                message: $this.$t("cart.itemAdded"),
                position: "bottom",
              });
              $this.$router.back(-1);
              //$this.$router.push({ name: "shoppingCart" });
            } else {
              $this.$toast({
                message: rpdata.data.meta.msg,
                position: "bottom",
              });
            }
          })
          .catch(function(err) {}); // eslint-disable-line
      } else {
        $this.$router.push({ name: "member" });
      }
    },
  },
};
</script>

<style>
#product {
  width: 100%;
  /* margin-bottom: 50px; */
}
/* #product .header {
  height: 44px;
  line-height: 44px;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
  background-color: white;
} */
#product .footer {
  height: calc(60px + env(safe-area-inset-bottom));
  line-height: 40px;
  overflow: hidden;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 99;
  background-color: white;
  box-shadow: 3px 3px 3px 1px black;
}
#product .title {
  text-transform: uppercase;
  font-size: 17px;
  line-height: 36px;
  font-weight: 700;
  color: #555555;
}
#product .code {
  font-size: 12px;
  font-weight: 700;
  color: #8d8c8c;
}
#product .product-note {
  color: red;
}
#product .price {
  /* position: fixed; */
  color: #ee4c30;
  /* margin-left: 15px; */
  font-size: 20px;
  /* font-family: "Roboto Condensed", sans-serif; */
}

#product .ori_price {
  text-decoration: line-through;
  color: #8b8b8b;
  margin-left: 10px;
}
#product .disc_price {
  /* background-color: #ea0000; */
  /* padding: 1px 5px; */
  /* border-radius: 5px; */
  /* color: #ffffff; */
}
#product .addto_cart {
  /* position: fixed; */
  background-color: #8cdbcc;
  /* width: 30%;  */
  color: black;
  text-align: center;
  z-index: 1;
  /* font-family: "Roboto Condensed", sans-serif; */
}
#product .addto_cart img {
  background-color: transparent;
}
#product .custom_service {
  position: fixed;
  bottom: 0;
  background-color: #ff868e;
  width: 30%;
  color: #ffffff;
  height: 40px;
  line-height: 40px;
  text-align: center;
  z-index: 1;
}
#product .selected {
  color: #fff;
  border-color: #f44;
  background: #f44;
}
#product .van-tab--active {
  color: #8cdbcc;
}
#product .van-tabs__line {
  background-color: #8cdbcc;
}
#product .van-col--9 {
  width: 33%;
}
#product .van-hairline--top-bottom::after {
  border-width: 0;
}
#product .carousel_browser {
  margin-top: 10px;
  margin-left: 25px;
}
#product .content_image_mobile {
  width: 100%;
}
#product .content_image_browser {
  width: 70%;
}
</style>
